import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IRelatedContent } from 'src/app/core/models/i-related-content';

@Component({
  selector: 'app-related-articles-item',
  templateUrl: './related-articles-item.component.html',
  styleUrls: ['./related-articles-item.component.scss'],
})
export class RelatedArticlesItemComponent {
  @Input() relatedArticle: FormControl<IRelatedContent>;

  @Output() handleRemove = new EventEmitter<IRelatedContent>();
  @Output() handleAdd = new EventEmitter<IRelatedContent>();
  @Output() handleAddToBody = new EventEmitter<IRelatedContent>();
  @Output() handleInfoClick = new EventEmitter<IRelatedContent>();

  onRemove(item: IRelatedContent) {
    this.handleRemove.emit(item);
  }

  onAdd(item: IRelatedContent) {
    this.handleAdd.emit(item);
  }

  onAddToBody(item: IRelatedContent) {
    this.handleAddToBody.emit(item);
  }

  onInfoClick(item: IRelatedContent) {
    this.handleInfoClick.emit(item);
  }
}
